import React from "react"
import { get } from "lodash"
import BasicCard from '../../components/BasicCard'
import "./ShowRecomendation.less"

export default class ShowRecomendation extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <div className="showRecomendation">
          <div className="listRecomendedButton">
            <div className="recomendType" >
              <div>&nbsp;</div>
              {
                this.props.categories.map(({tag, label}) => (
                  <button
                    key={tag}
                    className={this.props.selectRencButt == tag ? "active" : ""}
                    onClick={() => {
                      this.props.setRencButt({ selectRencButt: tag })
                    }}
                  >
                    {label}
                  </button>
                ))
              }
              <div>&nbsp;</div>
            </div>
          </div>
          <div
            className="recomendList"
          >
            {
              this.props.selectedCategory && (
                this.props.rankedProducts
                  .filter(this.props.selectedCategory.predicate)
                  .filter(product => !get(product, "relations.isShy", false))
                  .map(product => (
                    <div key={product._id} style={{padding: '5px 10px 5px 10px'}}>
                      <BasicCard
                        product={product}
                        onClick={() => {
                          this.props.setDestination({
                            destinationCoords: [product.preciseLocation.latitude, product.preciseLocation.longitude],
                            customDestinationAddress: product.chName
                          })
                          this.props.push(`/catalogo/${this.props.city}/transportation?step=showOrigin`)
                        }}
                      />
                    </div>
                  ))
              )
            }
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/catalogo/transportation/components/ShowRecomendation.jsx